import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import BetTableNotEnum from "../../casinoComponents/betTableNotEnum";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import MyBet from "../../casinoComponents/myBet";
import ViewMoreModal from "../../../components/ViewMoreModal";
import NoteNumCardsOverlay from "../../casinoComponents/videoBox/overlays/NoteNumCardsOverlay";
import NoteNumRefResults from "../resultui/resultNotEnum/NoteNumRefResults";
import { getCasinoGameDetails, getMatchExposure, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { formatNoteNumNation } from "../../../utils/casinoMyBets";
import "../../../styles/games/notenum.css";

export default function NotEnum() {
  const [gameData, setGameData] = useState(null);
  const [myBets, setMyBets] = useState([]);
  const [exposures, setExposures] = useState({});
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "notenum";
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`;
  const mid = gameData?.data?.data?.mid;

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(gameName);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const intervalId = setInterval(fetchGameData, 1500);
    return () => clearInterval(intervalId);
  }, [gameName]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName = item.team_name || item.selection || item.player_name || "";
            const amount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              exposureMap[teamName] = amount;
              exposureMap[teamName.toLowerCase()] = amount;
              exposureMap[teamName.trim()] = amount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [mid]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        setMyBets(response.data);
      }
    } catch (error) {
      console.error("Error fetching my bets:", error);
    }
  }, [gameName]);

  useEffect(() => {
    if (mid) {
      const t = setTimeout(fetchExposure, 0);
      const intervalId = setInterval(fetchExposure, 3000);
      return () => {
        clearTimeout(t);
        clearInterval(intervalId);
      };
    }
  }, [mid, fetchExposure]);

  useEffect(() => {
    const t = setTimeout(fetchMyBetsData, 0);
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => {
      clearTimeout(t);
      clearInterval(intervalId);
    };
  }, [fetchMyBetsData]);

  // Admin panel places no bets (the old PlaceBet here was the NoBet stub): a click refreshes book + bets.
  const handleBetClick = (label, value) => {
    if (!value) return;
    fetchExposure();
    fetchMyBetsData();
  };

  const d = gameData?.data?.data;
  const remark = d?.remark;

  return (
    <CasinoTableLayout
      tableClass="note"
      rightSide={<MyBet bets={myBets} formatNation={formatNoteNumNation} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name="Note Number" roundId={d?.mid ?? ""} />
        <VideoBox
          gameType={gameName}
          iframeSrc={iframeSrc}
          timerValue={d?.lt}
          cardsOverlay={<NoteNumCardsOverlay cardString={d?.card} />}
        />{" "}
        {d?.mid ? (
          <div className="casino-detail">
            <BetTableNotEnum data={d} onBetClick={handleBetClick} exposures={exposures} />{" "}
            {remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} />
                </div>{" "}
                <marquee>{remark}</marquee>
              </div>
            ) : null}{" "}
            <CasinoLastResult
              gameType={gameName}
              resultComponent={<NoteNumRefResults gameType={gameName} mid={d?.mid} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatNoteNumNation}
      />
    </CasinoTableLayout>
  );
}
